import React, { useEffect, useRef } from 'react';
import Message from './Message';
import './MessageList.css';

const MessageList = ({ messages, isLoading, isConnecting, agentState = 'listening', onClickableTextClick, t = {} }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Show typing indicator when:
  // - Agent is thinking or speaking
  // - OR when no messages yet (initial state)
  // - OR when explicitly loading
  const shouldShowTyping = (
    agentState === 'thinking' || 
    agentState === 'speaking' || 
    isLoading || 
    messages.length === 0
  );

  // Render system label (e.g., "Human Agent Joined")
  const renderSystemLabel = (msg) => (
    <div key={msg.id} className="system-label-wrapper">
      <div className={`system-label system-label-${msg.labelType || 'default'}`}>
        <span className="system-label-icon">👤</span>
        <span className="system-label-text">{msg.text}</span>
      </div>
    </div>
  );

  return (
    <div className="message-list">
      {messages.map((msg) => {
        // Handle system labels
        if (msg.sender === 'system-label') {
          return renderSystemLabel(msg);
        }
        
        // Handle regular messages (user, bot, human-agent)
        return (
          <Message 
            key={msg.id} 
            message={msg} 
            isUser={msg.sender === 'user'}
            isHumanAgent={msg.sender === 'human-agent'}
            onClickableTextClick={onClickableTextClick}
            t={t}
          />
        );
      })}
      {shouldShowTyping && (
        <div className="typing-indicator-wrapper">
          <div className="typing-indicator-header">
            <div className="typing-avatar">
              <img src="/assets/agent-logo.png" alt="Agent" className="agent-avatar-icon" />
            </div>
          </div>
          <div className="typing-indicator">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
